import { __extends } from "tslib";
import * as React from 'react';
import * as shape from 'd3-shape';
import { Arc } from '../Arc/index';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { getStyles } from './Pie.styles';
import { wrapTextInsideDonut } from '../../../utilities/index';
var getClassNames = classNamesFunction();
var TEXT_PADDING = 5;
var Pie = /** @class */ (function (_super) {
    __extends(Pie, _super);
    function Pie(props) {
        var _this = _super.call(this, props) || this;
        _this.arcGenerator = function (d, i, focusData, href) {
            var color = d && d.data && d.data.color;
            return (React.createElement(Arc, { key: i, data: d, focusData: focusData, innerRadius: _this.props.innerRadius, outerRadius: _this.props.outerRadius, color: color, onFocusCallback: _this._focusCallback, hoverOnCallback: _this._hoverCallback, onBlurCallback: _this.props.onBlurCallback, hoverLeaveCallback: _this.props.hoverLeaveCallback, uniqText: _this.props.uniqText, activeArc: _this.props.activeArc, href: href, calloutId: _this.props.calloutId, valueInsideDonut: _this.props.valueInsideDonut, theme: _this.props.theme, focusedArcId: _this.props.focusedArcId, showLabelsInPercent: _this.props.showLabelsInPercent, totalValue: _this._totalValue, hideLabels: _this.props.hideLabels }));
        };
        _this._focusCallback = function (data, id, e) {
            _this.props.onFocusCallback(data, id, e);
        };
        _this._computeTotalValue = function () {
            var totalValue = 0;
            _this.props.data.forEach(function (arc) {
                totalValue += arc.data;
            });
            return totalValue;
        };
        _this._hoverCallback = _this._hoverCallback.bind(_this);
        _this._pieForFocusRing = shape
            .pie()
            .sort(null)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .value(function (d) { return d.data; })
            .padAngle(0);
        return _this;
    }
    Pie.prototype.render = function () {
        var _this = this;
        var _a = this.props, pie = _a.pie, data = _a.data;
        var focusData = this._pieForFocusRing(data);
        var piechart = pie(data);
        var translate = "translate(" + this.props.width / 2 + ", " + this.props.height / 2 + ")";
        var classNames = getClassNames(getStyles, {
            theme: this.props.theme,
        });
        this._totalValue = this._computeTotalValue();
        return (React.createElement("g", { transform: translate },
            piechart.map(function (d, i) { return _this.arcGenerator(d, i, focusData[i], _this.props.href); }),
            this.props.valueInsideDonut && (React.createElement("text", { y: 5, textAnchor: "middle", dominantBaseline: "middle", className: classNames.insideDonutString, "data-is-focusable": true }, this.props.valueInsideDonut))));
    };
    Pie.prototype.componentDidUpdate = function () {
        var classNames = getClassNames(getStyles, {
            theme: this.props.theme,
        });
        wrapTextInsideDonut(classNames.insideDonutString, this.props.innerRadius * 2 - TEXT_PADDING);
    };
    Pie.prototype._hoverCallback = function (data, e) {
        this.props.hoverOnCallback(data, e);
    };
    Pie.defaultProps = {
        pie: shape
            .pie()
            .sort(null)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .value(function (d) { return d.data; })
            .padAngle(0.02),
    };
    return Pie;
}(React.Component));
export { Pie };
//# sourceMappingURL=Pie.js.map